// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './style.less'
import GetTextPlugin from 'vue-gettext'
import router from './router'
import translations from './translations.json'
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueLocalStorage from 'vue-localstorage'
import VueSession from 'vue-session'

Vue.use(ElementUI)
Vue.use(GetTextPlugin, {
  availableLanguages: {
    hu: 'Magyar',
    en: 'English',
    ro: 'Română'
  },
  defaultLanguage: 'hu',
  languageVmMixin: {
    computed: {
      currentKebabCase: function () {
        return this.current.toLowerCase().replace('_', '-')
      }
    }
  },
  translations: translations,
  silent: true
})
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAPS_API_KEY,
    libraries: 'places'
  }
})
Vue.use(VueLocalStorage)
Vue.use(VueSession)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js